import { CURRENCY_ORDER, currencyMeta } from '../currencies';
import { currencyUi } from '../data';

// The currency a donation is charged in. Sits above the amount grid on the
// donate, join and campaign pages.
//
// The same list on every frequency. It used to shrink to three currencies on
// the monthly tab (a `recurringOnly` prop) to match a per-account IsraelGives
// flag — see the DECIDED note in currencies.js for why monthly now offers the
// full list, and for how to put the narrowing back if their side refuses.
//
// A native <select> on purpose: it's one tap on a phone, where this mostly gets
// used, and the OS picker beats any custom listbox for that. The styling is all
// on the closed control (App.css) — the open menu is the platform's own.
export default function CurrencyPicker({ value, onChange, id }) {
  return (
    <div className="currency-picker">
      <label className="currency-picker-label" htmlFor={id}>
        <span className="bi-he">{currencyUi.label.he}</span>{' '}
        <span className="bi-ar">{currencyUi.label.ar}</span>
      </label>
      <div className="currency-picker-control">
        {/* No separate symbol glyph here: every option's text already leads
            with it ("₪ שקל / شيكل"), so the closed control shows it anyway and
            a second copy was both a duplicate and — because it needed
            direction:ltr to keep "C$" from reordering — positioned against the
            wrong edge, landing on top of the chevron. */}
        <select
          id={id}
          className="currency-picker-select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {CURRENCY_ORDER.map((code) => {
            const c = currencyMeta(code);
            return (
              <option key={code} value={code}>
                {`${c.symbol}  ${c.label.he} / ${c.label.ar}`}
              </option>
            );
          })}
        </select>
        <span className="currency-picker-arrow" aria-hidden="true" />
      </div>
    </div>
  );
}
